<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">订单管理</Breadcrumb-item>
        <Breadcrumb-item>销售成交率</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 10px">
      <Form :label-width="80" :show-message="false">
        <Row>
          <Col span="16">
            <Form-item label="统计周:">
              <DatePicker :value="dateRange" @on-change="onRangeChange" format="yyyy-MM-dd" type="daterange"
                          :clearable="false" placement="bottom-start" placeholder=""
                          style="width: 220px"></DatePicker>
              <Button type="primary" :loading="searchLoading" icon="search" style="margin-left: 8px" @click="search">搜索</Button>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="部门">
              <Select v-model="department" placeholder="请选择部门" clearable style="width: 100%">
                <Option v-for="item in $constant.adviserGroup" :key="item.code" :value="item.code">
                  {{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
    <Table :columns="columns" :data="list" :loading="searchLoading" :row-class-name="rowClassName"></Table>
    <div style="margin-top: 12px">
      合计：分配 {{ totalAssignCount }}，成交 {{ totalDealCount }}，成交率 {{ formatRate(totalDealRate) }}
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        searchLoading: false,
        startDate: '',
        endDate: '',
        dateRange: [],
        department: '',
        list: [],
        totalAssignCount: 0,
        totalDealCount: 0,
        totalDealRate: null,
        columns: [
          {
            title: '课程顾问',
            key: 'adviserName'
          },
          {
            title: '分配权重',
            key: 'assignWeight'
          },
          {
            title: '部门',
            render: (h, params) => {
              const group = this.$constant.getEnum(this.$constant.adviserGroup, params.row.department)
              return h('span', group && group.text)
            }
          },
          {
            title: '分配数量',
            render: (h, params) => {
              const count = params.row.assignCount == null ? 0 : params.row.assignCount
              const href = this.$router.resolve({
                path: '/crm/DistributionList',
                query: this.assignQuery(params.row)
              }).href
              return h('a', {
                attrs: { href: href },
                style: { color: '#2d8cf0' },
                on: {
                  click: (e) => {
                    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
                      return
                    }
                    e.preventDefault()
                    this.$router.push({
                      path: '/crm/DistributionList',
                      query: this.assignQuery(params.row)
                    })
                  }
                }
              }, String(count))
            }
          },
          {
            title: '成交数量',
            render: (h, params) => {
              const count = params.row.dealCount == null ? 0 : params.row.dealCount
              const href = this.$router.resolve({
                path: '/order/performanceDetail',
                query: this.dealQuery(params.row)
              }).href
              return h('a', {
                attrs: { href: href },
                style: { color: '#2d8cf0' },
                on: {
                  click: (e) => {
                    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
                      return
                    }
                    e.preventDefault()
                    this.$router.push({
                      path: '/order/performanceDetail',
                      query: this.dealQuery(params.row)
                    })
                  }
                }
              }, String(count))
            }
          },
          {
            title: '成交率',
            render: (h, params) => h('span', this.formatRate(params.row.dealRate))
          }
        ]
      }
    },
    created () {
      const startDate = this.$route.query.startDate
      const endDate = this.$route.query.endDate
      const weekStart = this.$route.query.weekStart
      const weeks = this.$route.query.weeks
      if (startDate && endDate) {
        this.setRange(startDate, endDate)
        this.search()
      } else if (weekStart && String(weeks) === '8') {
        const start = this.$moment(weekStart, 'YYYY-MM-DD').startOf('isoWeek')
        this.setRange(start.format('YYYY-MM-DD'), start.clone().add(55, 'days').format('YYYY-MM-DD'))
        this.search()
      } else if (weekStart) {
        const start = this.$moment(weekStart, 'YYYY-MM-DD').startOf('isoWeek')
        this.setRange(start.format('YYYY-MM-DD'), start.clone().add(6, 'days').format('YYYY-MM-DD'))
        this.search()
      } else {
        this.applyRecentEightWeeks()
        this.search()
      }
    },
    methods: {
      setRange (start, end) {
        this.startDate = start
        this.endDate = end
        this.dateRange = [start, end]
      },
      onRangeChange (value) {
        if (!value || !value[0] || !value[1]) {
          this.dateRange = [this.startDate, this.endDate]
          return
        }
        this.setRange(value[0], value[1])
      },
      applyRecentEightWeeks () {
        const start = this.$moment().startOf('isoWeek').subtract(7, 'weeks')
        this.setRange(start.format('YYYY-MM-DD'), start.clone().add(55, 'days').format('YYYY-MM-DD'))
      },
      inclusiveDays () {
        if (!this.startDate || !this.endDate) {
          return 0
        }
        const start = this.$moment(this.startDate, 'YYYY-MM-DD')
        const end = this.$moment(this.endDate, 'YYYY-MM-DD')
        return end.diff(start, 'days') + 1
      },
      assignQuery (row) {
        return {
          salesDealRate: 1,
          weekStart: this.startDate,
          startDate: this.startDate,
          endDate: this.endDate,
          adviserId: row.adviserId,
          linkStartTimeDate: this.startDate,
          linkEndTimeDate: this.endDate
        }
      },
      dealQuery (row) {
        return {
          salesDealRate: 1,
          weekStart: this.startDate,
          startDate: this.startDate,
          endDate: this.endDate,
          adviserId: row.adviserId
        }
      },
      formatRate (rate) {
        if (rate === null || rate === undefined || rate === '') {
          return '-'
        }
        return this.$numeral(Number(rate) * 100).format('0.00') + '%'
      },
      rowClassName (row) {
        if (row.dealRate === null || row.dealRate === undefined || row.dealRate === '') {
          return ''
        }
        const limit = this.inclusiveDays() === 56 ? 0.1 : 0.07
        return Number(row.dealRate) < limit ? 'low-deal-rate' : ''
      },
      search () {
        this.searchLoading = true
        const params = {
          startDate: this.startDate,
          endDate: this.endDate
        }
        if (this.department) {
          params.department = this.department
        }
        this.$http.get('/userinfo/salesDealRate', {
          params: params
        }).then(res => {
          const data = res.data || {}
          this.list = data.list || []
          this.totalAssignCount = data.totalAssignCount || 0
          this.totalDealCount = data.totalDealCount || 0
          this.totalDealRate = data.totalDealRate
          this.searchLoading = false
        }).catch(() => {
          this.searchLoading = false
        })
      }
    }
  }
</script>
<style lang="less" scoped>
.list /deep/ .ivu-table-tbody tr.low-deal-rate td {
  background-color: #fff1f0;
}
.list /deep/ .ivu-table-tbody tr.low-deal-rate:hover td {
  background-color: #ffe8e6;
}
</style>



// WEBPACK FOOTER //
// SalesDealRate.vue?252ac326